import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24bf4733"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "openMember" }
const _hoisted_2 = {
  key: 0,
  class: "newMemberInfo flex-cen-ter"
}
const _hoisted_3 = { class: "numBack flex-cen-ter" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "flex-cen-ter"
}
const _hoisted_6 = {
  key: 0,
  class: "symbol"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "numBack flex-cen-ter" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "flex-cen-ter"
}
const _hoisted_11 = {
  key: 0,
  class: "symbol"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 1,
  class: "wrap flex -bwn ter"
}
const _hoisted_14 = {
  key: 0,
  class: "tips-text"
}
const _hoisted_15 = {
  key: 1,
  class: "tips-text"
}

import { computed } from 'vue'
import { useRtfix, isJA, useSite } from '@/store'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import MemberBanner from '@/components/bussiness/MemberBanner.vue'
import { getActivePriceByStation, getCurrentMonetaryUnit } from '@/util/useYan'
import { Site } from '@/common/const'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const isSub = store.getters.isSub
const membership = store.getters.membership
const newMemberActivity = computed(() => store.state.status.newMemberActivity.id ? store.state.status.newMemberActivity : false)
console.log(newMemberActivity.value, 'newMemberActivity', newMemberActivity.value.specialPrice)

const currentMonetaryUnit = getCurrentMonetaryUnit()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(newMemberActivity))
      ? (_openBlock(), _createBlock(MemberBanner, { key: 0 }, {
          default: _withCtx(() => [
            (_unref(isJA)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_unref(t)("首次入会")) + " ", 1),
                  _createElementVNode("div", _hoisted_3, [
                    (_unref(newMemberActivity).hasSpecialTrialDiscount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(newMemberActivity).specialPrice), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                          _createTextVNode(_toDisplayString(_unref(newMemberActivity).specialPrice) + " ", 1),
                          (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "％"))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(newMemberActivity).hasSpecialTrialDiscount ? _unref(currentMonetaryUnit) : 'OFF') + _toDisplayString(_unref(t)('で中国輸入代行サービス体験可能！')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["newMemberInfo flex-cen-ter", _unref(useSite)()])
                }, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("首次入会")), 1),
                  (_unref(newMemberActivity).hasSpecialTrialDiscount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(currentMonetaryUnit)) + "  ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    (_unref(newMemberActivity).hasSpecialTrialDiscount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(newMemberActivity).specialPrice), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createTextVNode(_toDisplayString(_unref(newMemberActivity).specialPrice) + " ", 1),
                          (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "％"))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString('OFF')))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('で中国輸入代行サービス体験可能！')), 1)
                ], 2))
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_unref(isSub))
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(t)('开通会员，立享下单代买服务。请联系主账号开通。')), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(t)('开通会员，立享下单代买服务')), 1)),
          _createVNode(_component_router_link, {
            to: _unref(useRtfix)('VipLevel')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, { class: "btn" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(isSub) ? _unref(t)('查看会员') : _unref(t)('开通会员')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]))
  ]))
}
}

})